import {PageHeader, EitjeButton, AdvancedTableOptions} from '~/components'
import {TABLE_INFO} from '~/components/advanced_table/instances/invoices/constants'

const MOLLIE_URL = 'https://my.mollie.com/dashboard/org_12481518/payments'

export const InvoicesPageHeader = () => {
	return (
		<PageHeader
			label="common.unpaid_invoices"
			left={<EitjeButton externalLink={MOLLIE_URL} iconLeft="external-link" t="invoices.inspect_mollie" />}
			right={<AdvancedTableOptions {...TABLE_INFO} />}
		/>
	)
}
